import { IAppState } from 'shared/common/state';

export const isLoadingSelector = (state: IAppState): boolean => {
  return state.consultantCianChat.isLoading;
};
